<template>
  <section>
    <h3 class="title is-spaced">Usuàries</h3>
    
    <table class="encaixat mt-2 table is-full">
      <thead>
        <th>Nom</th>
        <th>Email</th>
        <th>Rol</th>  
      </thead>
    <tbody>
      <tr v-for="u in users" v-bind:key="u.id">
        <td>
          <router-link class="zbutton" v-bind:to="`/admin/user/${u.id}`">
            {{ u.name }}
          </router-link>          
        </td>
        <td>
          {{ u.email }}
        </td>
        <td>
          {{ u.role }}
        </td>
      </tr>
      
    </tbody>
  </table>

    <!-- <div class="col1">
      <h3 class="title">Users</h3>
      <pre v-for="user in users" v-bind:key="user.id" style="margin:20px">        
        <router-link v-bind:to="`/admin/user/${user.id}`">
          {{ user }}
        </router-link>
      </pre>

    </div> -->
    
  </section>
</template>

<script>
import { mapState } from "vuex";
const fb = require("../firebaseConfig.js");

export default {  
  data () {
    return {
      users: []
    }
  },
  computed: {
    ...mapState(["userProfile", "currentUser"])
  },
  mounted () {    
    if (this.userProfile.role !== 'admin') {
      this.$router.push('/')
    }

    fb.usersCollection.get().then(docs => {
      docs.forEach(doc => {
        let user = doc.data()
        user.id = doc.id
        this.users.push(user)
      })

    });
  },
  methods: {
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Admin.vue